<template>
    <div>
        <div class="approvalFlowConfiguration-title">{{$t('approvalFlowConfigManagement.approvalFlow.title')}}</div>
        <div class="approvalFlowConfiguration-top">
            <approval-flow-configuration-search></approval-flow-configuration-search>
        </div>
        <table-approval-flow-configuration></table-approval-flow-configuration>
    </div>
</template>

<script>
    import ApprovalFlowConfigurationSearch from '../approval_flow/ApprovalFlowConfigurationSearch'
    import TableApprovalFlowConfiguration from '../approval_flow/TableApprovalFlowConfiguration'

    export default {
        name: 'ApprovalFlowConfiguration',
        components: {
            ApprovalFlowConfigurationSearch,
            TableApprovalFlowConfiguration
        }
    }
</script>

<style scoped>
    .approvalFlowConfiguration-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .approvalFlowConfiguration-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/approval_flow/ApprovalFlowConfiguration.vue